import '@fontsource/quattrocento-sans/400.css';
import { config } from 'zod';
import '@fontsource/quattrocento-sans/700.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { OidcProvider } from './auth/OidcProvider';
import { SILENT_CALLBACK_PATH, completeSilentCallback } from './auth/userManager';
import { App } from './app/App';
import './styles.css';

// zod compiles object schemas with `new Function` unless told not to, and probes for it first. Under
// `script-src 'self'` the probe is refused - harmlessly, it falls back - but the browser reports
// every refusal as a CSP violation, which would bury a real one. The API reference's renderer
// validates its configuration with the same zod instance; it is the one user left in the portal.
config({ jitless: true });

// The renewal iframe lands here. It is answered before React is touched: this document exists only
// to hand a token response back to the window that opened it, and mounting the portal inside a
// hidden frame would start a second application with its own renewal timer.
if (window.location.pathname === SILENT_CALLBACK_PATH) {
  void completeSilentCallback();
} else {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
  });

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <OidcProvider><BrowserRouter><App /></BrowserRouter></OidcProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
